import { FormType, Formula } from '../../Formula';
export class FieldFormula extends Formula {
    static Matches(tree) {
        return tree.root.type === 'FieldLiteral';
    }
    constructor(tree, compiler) {
        super(tree, compiler);
        const fieldNode = tree.root;
        this._fieldName = fieldNode.value;
    }
    get fieldName() {
        return this._fieldName;
    }
    get form() {
        return FormType.FIELD;
    }
}
